import './api_query';
import './axios';
import './clipboard';
import './cookie';
import './fontawesome';
import './moment';
import './uiplugins';
import './vuelidate';
import './wait';
